export const getExpandedKeysByValue = (
  value: string | number,
  treeSelectorTiledMap
) => {
  const tempList: Array<string | number> = [];
  let parentNode = treeSelectorTiledMap[value];
  while (parentNode) {
    const pId = parentNode.pId;
    parentNode = treeSelectorTiledMap[pId];
    if (parentNode) {
      tempList.push(pId);
    }
  }
  return tempList;
};

export const getExpandedKeysByValues = (
  values: Array<string | number>,
  treeSelectorTiledMap
) => {
  if (values.length === 0) return [];
  const expandedKeys: Array<string | number> = [];
  values.forEach((value) => {
    const targetList = getExpandedKeysByValue(value, treeSelectorTiledMap);
    expandedKeys.push(...targetList);
  });
  return Array.from(new Set(expandedKeys));
};
